export default __webpack_public_path__ + "static/media/alert-icon-gray-banner.6e220464.svg";